import { useTranslation } from 'react-i18next'

import Table, { type Column } from '@/components/Table/Table'
import type { Pagination } from '@/hooks/usePagination'

import type { Group } from '../types'
import CourseExpandendRow from './CourseExpandedRow'

type CoursesListProps = {
  columns: Column<Group>[]
  list: Group[]
  count: number
  totalCount: number
  loading: boolean
  semesterId?: string
  withSplittedStudentsList?: boolean
  pagination: Pagination
}

const CoursesList = (props: CoursesListProps) => {
  const { t } = useTranslation('courses')
  return (
    <Table
      id="courses-table"
      data={props.list || []}
      isLoading={props.loading}
      columns={props.columns}
      count={props.count}
      totalCount={props.totalCount}
      {...props.pagination}
      expandedRowRender={record => (
        <CourseExpandendRow
          groupId={record.id}
          semesterId={props.semesterId}
          withSplittedStudentsList={props.withSplittedStudentsList}
        />
      )}
      caption={t('header.courses')}
    />
  )
}

export default CoursesList
